<mat-card-title mat-dialog-title>
  Termin bei {{ appointment.site.fullName}}
</mat-card-title>

<mat-card-content mat-dialog-content>
  <div>
    <mat-icon>date_range</mat-icon>
    {{ appointment.date_time | date:'shortDate' }}
  </div>
  <div>
    <p *ngIf="appointment.site.telephone">
      <mat-icon>phone</mat-icon>
      <a href="tel:{{ appointment.site.telephone }}">{{ appointment.site.telephone }}</a>
    </p>
  </div>
</mat-card-content>
<mat-card-actions mat-dialog-actions>
  <button mat-raised-button type="button" [color]="appointment.on_site ? 'primary' : 'default'"
          (click)="navigateTo(appointment.site)">navigieren
  </button>
  <a mat-raised-button type="button" [routerLink]="['/customer', appointment.site.customer.id]">Kunde ansehen</a>
  <a mat-raised-button *ngIf="appointment.report" type="button" [routerLink]="['/report', appointment.id]">Bericht ansehen</a>
  <a mat-raised-button *ngIf="appointment.isInPast && !appointment.report" type="button" [routerLink]="['/appointment', appointment.id, 'report']">Bericht erstellen</a>
  <button mat-raised-button type="button" color="warn" (click)="deleteAppointment(appointment)" *ngIf="appointment.report == null">löschen</button>
</mat-card-actions>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/appointment/appointment-detail/appointment-detail.component.html